exports.APIM_BASE_URL = `https://ist-h-euw-portal-apim.azure-api.net`;
exports.SUB_K = "d08f23beb6d247d6a5cb12837db5a8ca";

exports.HARDWARE_PRODUCTS = () => `/api/hardware/v1/`;

exports.HASH_PASSWORD =
  "8b5357782d4888ff5b40b315fab2d1f80cc1609d651e83e0c9d59eb18db93e90";
